export class Enterprise {
  name: string;
  contact: string;
  nit:string;
  telephone:string;
  email: string;
  address: string;
  web:string;
  location: string;
  password: string;
  password_repeat: string;
  jobcategory: string;
  jobcategory_id: number;
  plan: string;
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/models/enterprise.ts